import { useTranslation } from 'react-i18next';

const STRATEGIES = [
  { days: 1,  dailyProfit: '0.5%', apr: '182.50%', tier: 'starter',  popular: false },
  { days: 5,  dailyProfit: '0.7%', apr: '255.50%', tier: 'starter',  popular: false },
  { days: 10, dailyProfit: '0.8%', apr: '292.00%', tier: 'standard', popular: false },
  { days: 15, dailyProfit: '0.9%', apr: '328.50%', tier: 'standard', popular: false },
  { days: 20, dailyProfit: '1.0%', apr: '365.00%', tier: 'premium',  popular: false },
  { days: 25, dailyProfit: '1.1%', apr: '401.50%', tier: 'premium',  popular: false },
  { days: 30, dailyProfit: '1.2%', apr: '438.00%', tier: 'elite',    popular: true  },
];

const StrategiesSection = () => {
  const { t } = useTranslation();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="strategies" className="section-x strategies">
      <div className="dot-grid dot-grid--subtle" />

      <div className="container">
        <div className="row">
          <div className="col-lg-9 mx-auto text-center mb-5">
            <div className="eyebrow eyebrow--center mb-3" data-aos="fade-up">
              <span>{t('strategies.eyebrow')}</span>
            </div>
            <h2 className="section-heading" data-aos="fade-up">
              {t('strategies.titleLead')}{' '}
              <span className="gold-text">{t('strategies.titleHighlight')}</span>
            </h2>
            <p className="section-subheading" data-aos="fade-up" data-aos-delay="80">
              {t('strategies.subtitle')}
            </p>
          </div>
        </div>

        <div className="strategies__disclaimer" data-aos="fade-up">
          <i className="fas fa-lock" />
          <span>{t('strategies.disclaimer')}</span>
        </div>

        <div className="row g-3 g-lg-4 justify-content-center">
          {STRATEGIES.map((s, index) => (
            <div key={s.days} className="col-xl col-lg-4 col-md-6 col-sm-6">
              <div
                className={`strategy-card strategy-card--${s.tier}${s.popular ? ' strategy-card--popular' : ''}`}
                data-aos="fade-up"
                data-aos-delay={index * 60}
              >
                {s.popular && (
                  <div className="strategy-card__badge">
                    {t('strategies.mostPopular')}
                  </div>
                )}

                <div className="strategy-card__glow" aria-hidden="true" />

                <div className="strategy-card__duration">
                  <span className="strategy-card__days mono tabular-nums">{s.days}</span>
                  <span className="strategy-card__days-label">{t('strategies.days')}</span>
                </div>

                <div className="strategy-card__apr-block">
                  <div className="strategy-card__apr gold-text tabular-nums">{s.apr}</div>
                  <div className="strategy-card__apr-label">{t('strategies.apr')}</div>
                </div>

                <div className="strategy-card__rows">
                  <div className="strategy-card__row">
                    <span>{t('strategies.profit')}</span>
                    <span className="strategy-card__row-value highlight">
                      {s.dailyProfit} / {t('strategies.day')}
                    </span>
                  </div>
                  <div className="strategy-card__row">
                    <span>{t('strategies.minDeposit')}</span>
                    <span className="strategy-card__row-value">5 USDT</span>
                  </div>
                  <div className="strategy-card__row">
                    <span>{t('strategies.reinvest')}</span>
                    <span className="strategy-card__row-value">
                      <i className="fas fa-check" />
                    </span>
                  </div>
                </div>

                <button
                  type="button"
                  className={`strategy-card__cta ${s.popular ? 'tg-btn' : 'tg-btn-two'}`}
                  onClick={() => scrollTo('calculator')}
                >
                  {t('strategies.cta', { days: s.days })}
                  <i className="fas fa-arrow-right" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StrategiesSection;
